import * as React from 'react';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { observer } from 'mobx-react-lite';
import convertLayoutPositionToStyles from '../../../utils/convertLayoutPositionToStyles';
import type { SurfaceItem } from '../../../interfaces/SurfaceItem';
import type { ItemsLayout } from '../../../interfaces/ItemsLayout';

export interface ColumnFreeBusyContentProps {
    itemsLayout: ItemsLayout;
    busyModelsProvider: () => SurfaceItem[];
    template: (model: CalendarEvent) => JSX.Element;
}

/**
 * Shows color shadings on grid column for 'not-Free' all day events
 */
export default observer(function ColumnFreeBusyContent(props: ColumnFreeBusyContentProps) {
    let { itemsLayout, busyModelsProvider, template } = props;

    if (!template) {
        return null;
    }

    const results = busyModelsProvider().map(item => {
        let layout = itemsLayout.getVerticalLayout(item);
        let style = convertLayoutPositionToStyles(layout);

        let element = template(item.model);
        let mergedStyle = { ...style, ...element.props.style };
        return React.cloneElement(element, { ...{ style: mergedStyle } });
    });

    return <>{results}</>;
});
